import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AnalyticsService } from '../../services/analytics-service';
import Global from '../../store/global-selectors';

export const NavigationTracking = ({ history, children }) => {
  const sellerId = useSelector(Global.selectSellerSellerId);

  useEffect(() => {
    return history.listen((location) => {
      const { pathname = 'unknown-page-path', search = '' } = location || {};
      const metadata = { sellerId };
      AnalyticsService.trackPage(`${pathname}${search}`, metadata);
    });
  }, [history, sellerId]);

  return children;
};
